import { payrollRepos } from './tables';

/**
 * Số liệu cho báo cáo công lương: mọi kỳ đã duyệt (để chọn năm) và dòng chi tiết của các kỳ trong năm đang xem.
 * Đọc chi tiết theo từng kỳ để AppSheet chỉ trả về các dòng cần dùng.
 */
export async function loadApprovedPayroll(year) {
    const periods = await payrollRepos.periods.listWhere('TRANG_THAI', 'DA_DUYET');
    const inYear = year == null ? periods : periods.filter((period) => period.NAM === year);
    const details = (await Promise.all(inYear.map((period) => payrollRepos.periodDetails.listWhere('BANG_ID', period.MA_KY)))).flat();
    return { periods, details };
}

/** Sổ tiền giữ lại: mọi kỳ đã duyệt (số giữ lại cộng dồn qua các năm) và nhân sự để biết ai đã nghỉ. */
export async function loadRetentionData() {
    const [payroll, employees] = await Promise.all([loadApprovedPayroll(null), payrollRepos.employees.list()]);
    return { ...payroll, employees };
}
